module.exports = __webpack_public_path__ + "static/img/png.93398985.png";